// /src/components/AddStreamModal.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function AddStreamModal({
  open,
  onClose,
  url,
  onUrlChange,
  isValid,
  checking,
  checkError,
  streamName,
  setStreamName,
  onAdd,
}) {
  const { t } = useTranslation("common");
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(92vw, 560px)",
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 12px 32px rgba(0,0,0,.25)",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            background: "#00723a",
            color: "#fff",
            padding: "16px 22px",
            fontWeight: 800,
            fontSize: 20,
            letterSpacing: ".3px",
          }}
        >
          {t("modals.add_stream.title")}
        </div>

        <div style={{ padding: "20px 22px 22px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
            <input
              type="text"
              placeholder={t("modals.add_stream.name_placeholder")}
              value={streamName}
              onChange={(e) => setStreamName(e.target.value)}
              required
              style={{
                flex: 1,
                padding: "12px 16px",
                fontSize: 16,
                borderRadius: 8,
                border: "1px solid #bbb",
              }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
            <input
              type="text"
              placeholder={t("modals.add_stream.url_placeholder")}
              value={url}
              onChange={onUrlChange}
              style={{
                flex: 1,
                padding: "12px 16px",
                fontSize: 16,
                borderRadius: 8,
                border: "1px solid #bbb",
              }}
            />
            <span
              title={
                isValid
                  ? t("modals.add_stream.url_valid")
                  : t("modals.add_stream.url_invalid")
              }
              style={{
                width: 22,
                height: 22,
                borderRadius: "50%",
                background: isValid ? "#42d96c" : "#e54848",
                border: "2px solid #888",
                display: "inline-block",
              }}
            />
          </div>

          {/* Резервируем фиксированное место под сообщение статуса/ошибки, чтобы модалка не дёргалась */}
          <div
            style={{
              minHeight: 22,
              marginBottom: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            {checking ? (
              <div style={{ color: "#888" }}>{t("modals.add_stream.checking")}</div>
            ) : (!isValid && url.trim() ? (
              <div style={{ color: "#e54848" }}>
                {checkError || t("modals.add_stream.invalid_url")}
              </div>
            ) : null)}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
            <button
              onClick={onClose}
              style={{
                padding: "10px 18px",
                fontSize: 16,
                borderRadius: 8,
                border: "1px solid #ddd",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              {t("common.cancel")}
            </button>
            <button
              onClick={onAdd}
              disabled={!isValid || !streamName.trim()}
              style={{
                padding: "10px 18px",
                fontSize: 16,
                borderRadius: 8,
                border: "none",
                background: "#00723a",
                color: "#fff",
                fontWeight: 700,
                opacity: !isValid || !streamName.trim() ? 0.6 : 1,
                cursor: !isValid || !streamName.trim() ? "not-allowed" : "pointer",
              }}
            >
              {t("common.add")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
